module.exports = __webpack_public_path__ + "img/IMG_8957.7d65fdbd.jpg";